import { takeLatest } from 'typed-redux-saga';

export function takeLatestActionByString(actionType: string, saga: Parameters<typeof takeLatest>[1]) {
    return takeLatest(actionType, saga);
}
